import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { ListingDescriptionView } from "./ListingDescriptionView"

export interface GetListingDescriptionViewPathParams {
	inventoryId: string
}

export const getListingDescriptionViewRoute: ApiRoute<
	GetListingDescriptionViewPathParams,
	NoQueryParams,
	NoBody,
	ListingDescriptionView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/listing-description`,
	method: "get",
	path: "/vehicles/:inventoryId/listing-description",
}
